






import { Component, Vue } from 'vue-property-decorator'
import { getKey } from '@/api/login'
import { DingTalk } from '../index.d'
import { ddRedirectUri } from '@/config'
// import { Route } from 'vue-router'
// import { UserModule } from '@/store/modules/user'

declare let DDLogin:any
declare let window: any

@Component({
  name: 'QrCodeLogin'
})
export default class extends Vue {
  private appId = ''

  async created() {
    const { content } = await getKey<DingTalk>()
    this.appId = content.appKey
    console.log(this.appId)
    this.$nextTick(() => {
      DDLogin({
        id: 'qr-code',
        goto: encodeURIComponent(`https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${ddRedirectUri()}`),
        style: 'background-color:#FFFFFF;',
        width: '300',
        height: '320'
      })
    })
  }

  mounted() {
    // 监听钉钉扫码回调
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', this.handleMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', this.handleMessage)
    }
  }

  private async handleMessage(event: any) {
    var origin = event.origin
    if (origin === 'https://login.dingtalk.com') { // 判断是否来自ddLogin扫码事件。
      var loginTmpCode = event.data
      // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
      window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.appId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${ddRedirectUri()}&loginTmpCode=${loginTmpCode}`
    }
  }
}
